export const setSessionItem = (name, value) => {
  return localStorage.setItem(name, value);
};

export const getSessionItem = (name) => {
  return localStorage.getItem(name);
};
